import { IFrameDefault } from "./iframe-default";
import { IFrameQuery } from "./iframe-query";

export const IFrame = Object.assign(IFrameDefault, {
  Default: IFrameDefault,
  Query: IFrameQuery,
});

export type { IFrameDefaultProps } from "./iframe-default";
export type { IFrameQueryProps } from "./iframe-query";
